module.exports = __webpack_public_path__ + "img/Boulangerie.7eb33abc.jpg";